<template>
  <div class="u-wrap">
    <img src="@images/zhdj/dj-bg.png" class="img" />
    <van-grid clickable :column-num="4" :border="false" style="margin-top: 10px">
      <van-grid-item v-for="(item, index) in menuList" :key="index" @click="clickMenu(index)">
        <img :src="item.icon" class="grid-img" />
        <div class="grid-text">{{ item.title }}</div>
      </van-grid-item>
    </van-grid>
    <div class="card-title">
      <p>我行我SHOW</p>
      <p @click="clickMore">更多</p>
    </div>
    <wxws-list :list="dataList" :realname="realname"></wxws-list>
    <smrz-pop v-model="show"></smrz-pop>
  </div>
</template>

<script>
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import smrzPop from '@/views/common/smrz-pop.vue'
import wxwsList from '@/views/common/wswx-list.vue'
import { getAction, postAction, postParam } from '@/api/manage'
import Vue from 'vue'
const rol1 = ['bddy', 'dy']
const rol2 = ['expert']
const rol3 = ['djyt_dzb']
const rol4 = ['dy']
const rol5 = ['sjwgy', 'bddy']
export default {
  mixins: [OpenIdMixin], // 使用mixin (在main.js注册全局组件)
  components: {
    smrzPop,
    wxwsList,
  },
  data() {
    return {
      show: false,
      rzInfo: {},
      menuList: [
        {
          icon: require('@images/zhdj/icon-dyjy.png'),
          title: '党员教育',
        },
        {
          icon: require('@images/zhdj/icon-dyhd.png'),
          title: '党员活动',
        },
        {
          icon: require('@images/zhdj/icon-zjrc.png'),
          title: '专家人才',
        },
        {
          icon: require('@images/zhdj/icon-wtqhyb.png'),
          title: '问题墙回音壁',
        },
        {
          icon: require('@images/zhdj/icon-hdsyy.png'),
          title: '活动室预约',
        },
        {
          icon: require('@images/zhdj/icon-sbdwmx.png'),
          title: '双报到',
        },
        {
          icon: require('@images/zhdj/icon-wmx.png'),
          title: '为民行',
        },
      ],
      dataList: [],
      realname: '',
    }
  },
  created() {
    this.initOpenId()
      .then(() => {
        let userInfo = this.getSmrzData()
        this.realname = userInfo.wechatName
        this.getData()
      })
      .catch((err) => {})
  },
  mounted() {},
  computed: {},
  methods: {
    goSmrzPath(per, path) {
      if (!this.isSmrz()) {
        this.show = true
        return
      }
      if (this.checkPer(per)) {
        this.$router.push({ path: path })
      } else {
        this.$toast('当前角色无此权限')
      }
    },
    clickMenu(index) {
      switch (index) {
        case 0:
          this.goSmrzPath(rol1, '/dqfw/dyjy')
          break
        case 1:
          this.goSmrzPath(rol1, '/dqfw/dyhd-list')
          break
        case 2:
          this.goSmrzPath(rol2, '/dqfw/zjhf-list')
          break
        case 3:
          this.goSmrzPath(rol3, '/hmhq/problem')
          break
        case 4:
          this.goSmrzPath(rol4, '/dqfw/hdsyy-list')
          break
        case 5:
          this.goSmrzPath(rol5, '/dqfw/sbd-list')
          break
        case 6:
          this.goSmrzPath(rol5, '/gzfw/sbdwmx-list')
          break
        case 7:
          break
        default:
          break
      }
    },
    clickMore() {
      this.$router.push({ path: '/dqfw/wxws' })
    },
    getData() {
      let params = { pageNo: this.pageNo, pageSize: '3' }
      getAction('/zhshj/djylwxws/show/page', params).then((res) => {
        if (res.success) {
          let list = res.result.records
          this.dataList = list
        }
      })
    },
    checkPer(value) {
      if (value && value instanceof Array && value.length > 0) {
        const permissionRoles = value
        let roles = Vue.ls.get('roles', [])
        console.log(this.roles)
        return roles.some((role) => {
          return permissionRoles.includes(role)
        })
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #ffffff;
}
.img {
  width: 100%;
  height: auto;
}
.grid-img {
  width: 40px;
  height: 40px;
}

.grid-text {
  margin-top: 5px;
  font-size: 12px;
  color: #1a1a1a;
  text-align: center;
  height: 38px;
}

::v-deep .van-grid-item__content {
  padding: 0px 4px;
}

.card-title {
  width: 100%;
  position: relative;
  margin: 0px 0px 10px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  padding: 0 12px 8px 20px;
  font-size: 15px;
  p {
    margin: 0px;
    padding: 0px;
    letter-spacing: 1px;
  }
  p:last-child {
    color: #999;
  }
}
.card-title::before {
  content: '';
  width: 4px;
  height: 24px;
  position: absolute;
  left: 12px;
  top: 0px;
  background: #39a9ed;
}
</style>
